import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
// components
import Logo from 'src/components/Logo';

// @mui
import { Box, Typography, Toolbar } from '@mui/material';
import useAuth from 'src/hooks/commonUseAuth';
// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'relative',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

// ----------------------------------------------------------------------

CommonLayout.propTypes = {
  children: PropTypes.node,
};

export default function CommonLayout({ children }) {
  const { user, logout, adminLogut, user_type } = useAuth();
  const isSuperAdmin = user_type === "user";

  return (
    <>
      <HeaderStyle>
        <Toolbar
          sx={{
            minHeight: '100% !important',
            px: { lg: 5 },
          }}
        >
          <Logo />
          <Box sx={{ flexGrow: 1 }} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ my: 1.5, px: 2.5 }}>
              <Typography variant="subtitle2" noWrap>
                {user?.name}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                {user?.email}
              </Typography>
            </Box>
            <Typography
              onClick={() => {
                isSuperAdmin ? adminLogut() : logout();
              }}
              variant="subtitle2"
              sx={{ color: 'text.secondary', cursor: 'pointer' }}
              noWrap
            >
              Logout
            </Typography>
          </div>
        </Toolbar>
      </HeaderStyle>
      {children}
    </>
  );
}
